const STORAGE_KEY = "csrp_admin_dashboard_state";

export function saveAdminDashboardState(state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readAdminDashboardState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAdminDashboardState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function readAdminDashboardRestoreSnapshot() {
  const saved = readAdminDashboardState();
  if (!saved?.pendingRestore) return null;
  return saved;
}

export function markAdminDashboardPendingRestore() {
  const saved = readAdminDashboardState();
  if (!saved) return;
  saveAdminDashboardState({ ...saved, pendingRestore: true });
}

export function markAdminDashboardRestored() {
  const saved = readAdminDashboardState();
  if (!saved) return;
  saveAdminDashboardState({ ...saved, pendingRestore: false });
}
